import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { Qualtrics } from '@shared-ui/customer-qualtrics';

export const QualtricsExperiments: React.FC = () => (
    <Experiment name="Lodging_PWA_Qualtrics">
      <ExperimentControl>
        <Experiment name="Tiered_MODs_Traveller_Experience_Hcom_Web">
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <Qualtrics />
          </ExperimentVariant>
        </Experiment>
        <Experiment name="Tiered_MOD_Traveler_Experience_BEX_Web">
          <ExperimentControl />
          <ExperimentVariant bucket={1}>
            <Qualtrics />
          </ExperimentVariant>
        </Experiment>
      </ExperimentControl>
      <ExperimentVariant bucket={1}>
        <Qualtrics />
      </ExperimentVariant>
    </Experiment>
  );

QualtricsExperiments.displayName = 'QualtricsExperiments';
